angular.module('impactx.catalog').directive('ixVCatalogData', function ()
{
    return {
        scope: {
            vcat: "=",
            dialogData: "=",
            catname: "=",
            trns: "=",
            tinymceOptions: "=",
            isExternal: "="
        },
        restrict: 'E',
        templateUrl: 'modules/catalog/templates/vcatalogdata.tmpl.html',
        transclude: true
    };
});